module.exports = __webpack_public_path__ + "c023e1c43a5ebba41709a1d1fb3644fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/testPages/welcome/assets/ok.png
// module id = 712
// module chunks = 0